//
//  AdminMain.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { ReactElement, useCallback } from "react";
import { AdminMainDefault } from "./component/AdminMain/Default";
import { BLOOD_PRESSURE_USED } from "./utils/env";
import { AdminMainBloodPressureOnly } from "./component/AdminMain/BloodPressureOnly";
import { useLogout } from "./hooks/useLogout";

const AdminMain = (): ReactElement => {
  const doLogout = useLogout();
  const logout = useCallback(
    async (event: any) => {
      event.preventDefault();

      await doLogout();
    },
    [doLogout]
  );
  return BLOOD_PRESSURE_USED ? (
    <AdminMainBloodPressureOnly logout={logout} />
  ) : (
    <AdminMainDefault logout={logout} />
  );
};

export default AdminMain;
